export const levelOfStudyOptions = [
  { value: "UG", label: "Undergraduate" },
  { value: "PG", label: "Postgraduate" },
  { value: "PhD", label: "Doctor of Philosophy" },
  { value: "Non Student", label: "Non-Student" },
];
